module.exports = __webpack_public_path__ + "img/image (39).35105fcc.jpg";